'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@algoacademy/design-system/web/actions/Button';
import { showErrorToastWithAlgoPhoneNumber } from '@algoacademy/design-system/web/feedback/Toaster/ToasterError';
import { Input } from '@algoacademy/design-system/web/forms/Input';
import { VerticalSpacer } from '@algoacademy/design-system/web/layouts/VerticalSpacer';
import { H3 } from '@algoacademy/design-system/web/marketing/typography/Heading';
import { P2 } from '@algoacademy/design-system/web/marketing/typography/Paragraph';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { useMutation } from '@tanstack/react-query';
import { useForm } from 'react-hook-form';
import { toast } from 'sonner';
import { useTRPC } from '@/app/_trpc/config';
type EbookForm = {
  email: string;
};
export function EbookPopup(t0) {
  const $ = _c(27);
  const {
    open,
    onClose
  } = t0;
  const {
    register,
    handleSubmit,
    reset
  } = useForm();
  const trpc = useTRPC();
  let t1;
  if ($[0] !== trpc.notifications.sendEmails) {
    t1 = trpc.notifications.sendEmails.mutationOptions();
    $[0] = trpc.notifications.sendEmails;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const sendEmailMutation = useMutation(t1);
  let t2;
  if ($[2] !== onClose || $[3] !== reset || $[4] !== sendEmailMutation) {
    t2 = async data => {
      try {
        await sendEmailMutation.mutateAsync({
          emailData: {
            subject: "E-book: Nasza metoda nauczania - AlgoAcademy",
            htmlContent: "\n        <!DOCTYPE html>\n        <html>\n        <body style=\"font-family: Arial, sans-serif; line-height: 1.6; color: #333;\">\n          <div style=\"max-width: 600px; margin: 0 auto; padding: 20px;\">\n            <h2 style=\"color: #2563eb;\">Dzi\u0119kuj\u0119 za zainteresowanie nasz\u0105 metod\u0105 nauczania :)</h2>\n            \n            <p>Dzie\u0144 dobry,</p>\n            \n            <p>jestem za\u0142o\u017Cycielem AlgoAcademy i jest mi niezmiernie mi\u0142o, \u017Ce chcesz dowiedzie\u0107 si\u0119 wi\u0119cej o naszej metodzie nauczania. Stara\u0142em si\u0119 w nim zawrze\u0107 problemy, z kt\xF3rymi zmagaj\u0105 si\u0119 m\u0142odzi informatycy, problemy aktualnego systemu i to, jak nasza metoda nauczania stara si\u0119 je rozwi\u0105za\u0107.</p>\n            \n            <p>Link do e-booka znajduje si\u0119 poni\u017Cej.</p>\n            \n            <div style=\"text-align: center; margin: 30px 0;\">\n              <a href=\"https://drive.google.com/file/d/1b4hy7urZ2M96ZXimAO6M2-qawq6RaQ9x/view?usp=sharing\" \n                 style=\"background-color: #2563eb; color: white; padding: 12px 24px; text-decoration: none; border-radius: 6px; display: inline-block; font-weight: bold;\">\n                Otw\xF3rz e-booka\n              </a>\n            </div>\n            \n            <p>Je\u015Bli masz jakiekolwiek pytania, mo\u017Cesz \u015Bmia\u0142o zada\u0107 je w odpowiedzi na ten email.</p>\n            \n            <p>Pozdrawiam serdecznie<br>\n            Rados\u0142aw My\u015Bliwiec<br>\n            Za\u0142o\u017Cyciel AlgoAcademy</p>\n          </div>\n        </body>\n        </html>\n      ",
            correspondents: {
              senderName: "Rados\u0142aw My\u015Bliwiec",
              senderEmail: "radoslaw.mysliwiec@algoacademy.pl",
              receiverName: "U\u017Cytkownik",
              receiverEmails: [data.email]
            }
          }
        });
        toast.success("E-book zosta\u0142 wys\u0142any!", {
          description: "Sprawd\u017A swoj\u0105 skrzynk\u0119 pocztow\u0105 - mail z e-bookiem powinien dotrze\u0107 w ci\u0105gu kilku minut."
        });
        reset();
        onClose();
      } catch {
        showErrorToastWithAlgoPhoneNumber();
      }
    };
    $[2] = onClose;
    $[3] = reset;
    $[4] = sendEmailMutation;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const onSubmit = t2;
  if (!open) {
    return null;
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <XMarkIcon className="h-6 w-6" />;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== onClose) {
    t4 = <button type="button" onClick={onClose} className="absolute top-4 right-4 text-gray-400 hover:text-gray-600">{t3}</button>;
    $[7] = onClose;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <H3>Pobierz darmowy e-book</H3>;
    t6 = <VerticalSpacer size="content" />;
    t7 = <P2>Podaj swój adres email, a wyślemy Ci szczegółowy e-book o naszej metodzie nauczania. Znajdziesz w nim szczegółowy opis genezy naszej metody i rozwiązań, które proponujemy.</P2>;
    t8 = <VerticalSpacer size="content" />;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    t5 = $[9];
    t6 = $[10];
    t7 = $[11];
    t8 = $[12];
  }
  let t9;
  if ($[13] !== handleSubmit || $[14] !== onSubmit) {
    t9 = handleSubmit(onSubmit);
    $[13] = handleSubmit;
    $[14] = onSubmit;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== register) {
    t10 = register("email", {
      required: true
    });
    $[16] = register;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10) {
    t11 = <Input type="email" placeholder={"Tw\xF3j adres email"} {...t10} className="w-full" />;
    $[18] = t10;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="flex gap-3"><Button type="submit" size="lg" className="flex-1">Wyślij e-book</Button></div>;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t11 || $[22] !== t9) {
    t13 = <form onSubmit={t9} className="space-y-4">{t11}{t12}</form>;
    $[21] = t11;
    $[22] = t9;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t13 || $[25] !== t4) {
    t14 = <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"><div className="relative w-full max-w-md rounded-lg bg-white p-6 shadow-xl">{t4}{t5}{t6}{t7}{t8}{t13}</div></div>;
    $[24] = t13;
    $[25] = t4;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  return t14;
}